import en from "./en";
import ar from "./ar";

export const DEFAULT_LANGUAGE = "en";
export const SUPPORTED_LANGUAGES = ["en", "ar"];
export const LANGUAGE_STORAGE_KEY = "eduos_lang";
export const catalogs = { en, ar };

export const normalizeLanguage = (language) => {
  const base = String(language || "").toLowerCase().split(/[-_]/)[0];
  return SUPPORTED_LANGUAGES.includes(base) ? base : DEFAULT_LANGUAGE;
};

export const getStoredLanguage = (storage = typeof window !== "undefined" ? window.localStorage : null) => {
  try {
    return normalizeLanguage(storage?.getItem(LANGUAGE_STORAGE_KEY));
  } catch {
    return DEFAULT_LANGUAGE;
  }
};

export const persistLanguage = (language, storage = typeof window !== "undefined" ? window.localStorage : null) => {
  const normalized = normalizeLanguage(language);
  try {
    storage?.setItem(LANGUAGE_STORAGE_KEY, normalized);
  } catch {
    // Storage can be unavailable in private or embedded browser contexts.
  }
  return normalized;
};

export const directionForLanguage = (language) =>
  normalizeLanguage(language) === "ar" ? "rtl" : "ltr";

export const applyLanguageDocument = (language, documentRef = typeof document !== "undefined" ? document : null) => {
  const normalized = normalizeLanguage(language);
  if (documentRef?.documentElement) {
    documentRef.documentElement.lang = normalized;
    documentRef.documentElement.dir = directionForLanguage(normalized);
  }
  return normalized;
};

const lookup = (catalog, key) => key.split(".").reduce((value, part) => value?.[part], catalog);

export const translate = (language, key, variables = {}) => {
  const normalized = normalizeLanguage(language);
  const value = lookup(catalogs[normalized], key) ?? lookup(catalogs[DEFAULT_LANGUAGE], key);
  if (typeof value !== "string") return key;
  return value.replace(/\{(\w+)\}/g, (_, variable) =>
    variables[variable] === undefined ? `{${variable}}` : String(variables[variable]),
  );
};
